<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » SPLATS情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>SPLATS情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/splats.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加(更新)ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が登録されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 共用環境アクセストークン
        </div>
        <div class="manual-explain">
          共用環境のアクセストークンを設定します。<br>
          アクセストークンはSPLATSの設定画面より取得してください。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 本番環境アクセストークン
        </div>
        <div class="manual-explain">
          本番環境のアクセストークンを設定します。<br>
          アクセストークンはSPLATSの設定画面より取得してください。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of SPLATS Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of SPLATS Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_splats.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add (Update) Button
        </div>
        <div class="manual-explain">
          Click to register the edited content.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Shared Environment Access Token
        </div>
        <div class="manual-explain">
          Set the access token for the shared environment.<br>
          Please obtain the access token from the SPLATS settings screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Production Environment Access Token
        </div>
        <div class="manual-explain">
          Set the access token for the production environment.<br>
          Please obtain the access token from the SPLATS settings screen.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
